package org.lennycodes.hldi.styles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val FooterWaveSvgStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .styleModifier {
                property("top", "-1px")
                property("left", "0")
                property("transform", "translateY(-100%)")
            }
            .width(100.percent)
            .height(80.px)
    }
}

@Composable
fun FooterWaveSvg() {
    Svg(
        attrs = FooterWaveSvgStyle.toAttrs {
            attr("viewBox", "0 0 1440 120")
            attr("preserveAspectRatio", "none")
        }
    ) {
        Path(
            attrs = {
                attr("fill", HLDITheme.Colors.primary.toString()) // match footer bg so it looks continuous
                attr("d", "M0,64 C240,120 480,0 720,32 C960,64 1200,120 1440,64 L1440,120 L0,120 Z")
            }
        )
    }
}